module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Stalden_COA-979350d3978fd4f952df608306f232d3.svg";